import styled from "styled-components"

const Title = styled.h1`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`
const SubTitle = styled.h3`
  color: ${(props) => props.theme.b_color_gradients.b_light};
  & ~ ul li,
  & ~ ul li > a {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`
const TaxoButton = styled.span`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`
const StyledFooter = styled.div`
  & > div {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`
const Separator = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
`

export { Title, SubTitle, TaxoButton, StyledFooter, Separator }
